import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IconButton, Menu, MenuItem } from '@mui/material'
import { Language as LanguageIcon } from '@mui/icons-material'
import { usePreferencesStore } from '../stores/preferencesStore'

const languages = [
  { code: 'es', label: 'Espanol' },
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
  { code: 'de', label: 'Deutsch' },
  { code: 'it', label: 'Italiano' },
  { code: 'ca', label: 'Català' },
  { code: 'eu', label: 'Euskara' },
]

export default function LanguageSwitcher() {
  const { i18n } = useTranslation()
  const { setLanguage } = usePreferencesStore()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const currentCode = i18n.language || 'es'

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSelect = (code: string) => {
    i18n.changeLanguage(code)
    setLanguage(code as 'en' | 'es' | 'fr' | 'de' | 'it' | 'ca' | 'eu')
    handleClose()
  }

  return (
    <>
      <IconButton color="inherit" onClick={handleOpen} title="Language">
        <LanguageIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {languages.map((lang) => (
          <MenuItem
            key={lang.code}
            selected={currentCode.startsWith(lang.code)}
            onClick={() => handleSelect(lang.code)}
          >
            {lang.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
